import { twMerge } from 'tailwind-merge';
import Title from '@/components/Title';
import { CompanyIcon } from '@/icons';
import Card from '@/components/Card';
import { formatNumber } from '@/utils/strings';
import { classes } from '../utils';

export type CompaniesCardProps = {
  className?: string;
  count: number;
};

export default function CompaniesCard({
  className,
  count,
}: CompaniesCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.textWrapper}>
        <div className={classes.label}>Companies</div>
        <Title size="md">{formatNumber(count)}</Title>
      </div>
      <div className={twMerge(classes.icon, classes.companyIcon)}>
        <CompanyIcon />
      </div>
    </Card>
  );
}
